import { render, staticRenderFns } from "./GenericMenu.vue?vue&type=template&id=dc4bb9be&scoped=true&"
import script from "./GenericMenu.vue?vue&type=script&lang=js&"
export * from "./GenericMenu.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/GenericMenu/GenericMenu.less?vue&type=style&index=0&id=dc4bb9be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4bb9be",
  null
  
)

export default component.exports